import styled from 'styled-components'
import { BLUE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface DivProps {
  searching?: boolean
}

export const RowMenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  transition: transform 0.25s ease-in;
  background-color: #231F20;
  padding-top: -20px;
  width: 100%;
`

export const StyledMenu = styled.div`
  overflow: hidden;
  background-color: #231F20;
  border-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: ${({ searching }: DivProps) => searching ? '10px 0px' : '10px 10px 10px 4px'};
  width: ${({ searching }: DivProps) => searching ? '0px' : '100%'};
  transition: all 0.25s ease-in-out;
  @media (min-width: 698px) {
    justify-content: space-evenly;
  }
`

export const SearchButton = styled.div`
  height: 100%;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  background-color: #231F20;
`

export const DismissableButton = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #cec9c9;
  width: ${({ searching }: DivProps) => searching ? '44px' : '0px'};
  transition: width 0.25s ease-in-out;
  background-color: #231F20;
`

export const SearchInput = styled.input`
  color: black;
  border-radius: ${({ searching }: DivProps) => searching ? '8px' : '0'};
  border: ${({ searching }: DivProps) => searching ? 'solid 1px gray' : 'none'};
  height: 74%;
  font-size: 16px;
  opacity: ${({ searching }: DivProps) => searching ? '1' : '0'};
  width: ${({ searching }: DivProps) => searching ? '294px' : '0px'};
  margin: ${({ searching }: DivProps) => searching ? '0 4px' : '0px'};
  padding: ${({ searching }: DivProps) => searching ? '16px 10px' : '0px'};
  background-color: white;
  transition: all 0.25s ease-in-out;
  input {
    border-radius: ${({ searching }: DivProps) => searching ? '8px' : '0'};
  }
`

export const OptionDropdown = styled.h1<{ $wrap: Boolean}>`
  padding: 0 6px;
  white-space: ${props => props.$wrap ? 'normal' : 'nowrap'};
  line-height: ${props => props.$wrap ? 'normal' : 'inherit'};
  text-transform: uppercase;
  align-content: center;
  font-size: 12px;
  color: white;
  @media (max-width: 498px) {
    font-size: 11.5px;
  }
`

export const TilesContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
`

export const Tile = styled.div`
  flex: 1 1 calc(33.333% - 20px);
  margin-left: 18px;
  margin-bottom: 10px;
  position: relative;
  &:last-child {
    margin-right: 0px;
  }
  &:hover {
    cursor: pointer;
    img {
      transform: scale(1.1);
      transform-origin: 50% 50%;
    }
    .subtitleTile {
      background: ${BLUE};
    }
  }
`

export const ContainerImage = styled.div`
  max-width: 92px;
  overflow: hidden;
  border-radius: 7px;
  box-shadow: 1px 2px 4px 0px gray;
`
export const TileImage = styled.img`
  width: 100%;
  transition: transform .25s;
`

export const TileSubtitle = styled.div`
  position: absolute;
  bottom: 0px;
  padding-left: 12px;
  background: #0000006e;
  max-width: 92px;
  color: white;
  left: 0;
  padding-bottom: 4px;
  padding-top: 4px;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  font-family: Avenir;
  font-weight: bold;
  font-size: 16px;
  transition: background .25s;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const RightArrowTile = styled(Icon)`
  font-size: 8px;
  color: #edf3ff;
  border: 1px solid #808ca4;
  border-radius: 25px;
  padding: 3px;
  margin-right: 12px;
`
export const ContentOptions = styled.div`
  margin-left: -14px;
  margin-right: -14px;
  z-index: inherit;
  .title {
    font-size: 13px;
    text-align: center;
    font-weight: bold;
    font-family: Avenir;
    color: #4e4e4e;
  }
`

export const ContentItem = styled.div`
  font-size: 16px;
  padding: 6px 18px;
  padding-right: 14px;
  font-family: Avenir;
  display: flex;
  align-items: center;
  transition: all .25s;
  &:hover {
    background: whitesmoke;
    border-radius: 5px;
    color: cornflowerblue;
    cursor: pointer;
  }
`

export const ContentIcon = styled.img`
  margin-right: 10px;
  max-width: 38px;
  align-self: flex-start;
  margin-top: 8px;
  margin-left: -2px;
`
export const ContentName = styled.div`
  max-width: 100%;
  width: 100%;
  font-size: 14px;
  font-family: Avenir;
  .subtitle {
    display: inline-block;
    font-size: 12px;
    font-weight: 500;
    margin-left: 8px;
    margin-top: -2px;
    vertical-align: middle;
  }
`

export const DescriptionContent = styled.div`
  font-size: 12px;
  color: gray;
  font-family: Avenir;
  font-weight: normal;
  line-height: 1.45;
`

export const RightArrow = styled(Icon)`
  font-size: 12px;
  color: #4e7cd0;
  margin-left: 8px;
  border: 1px solid #4e7cd0;
  border-radius: 25px;
  padding: 3px;
`

export const PopoverComp = styled.div`
  display: flex;
  flex-flow: column;
  position: absolute;
  background: white;
  top: 54px;
  left: 0;
  height: 100vh;
  padding: 10px 12px;
  color: #5F6062;
  overflow-y: hidden;
  z-index: 1;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MobileTopMenuBar/styledComponents.tsx